import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from '@/components/atoms/button';
import { EmailChangeContainer } from '@/features/settings';

export default function SettingsProfileEmailPage() {
  const { t } = useTranslation();

  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <Link to="/settings/profile">
          <Button variant="ghost" size="icon-sm">
            <ChevronLeft className="size-4" />
          </Button>
        </Link>
        <h1 className="text-2xl font-bold tracking-tight">{t('settings.email.title')}</h1>
      </div>

      <div className="max-w-xl">
        <EmailChangeContainer />
      </div>
    </div>
  );
}
